"use strict";
/**
 * Weekly Report V3 — Beat 1 Hook Observation
 *
 * Optional hook callout that sits under the cover hero. New reports emit a
 * HookObservation with a type tag (for visual accent) and either a body string
 * (LLM-generated for non-window types) or windowParams (interpolation data for
 * i18n rendering of window observation types). Historical reports without this
 * field render the cover unchanged.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookObservationSchema = exports.HookWindowParamsSchema = exports.HookTypeEnum = void 0;
const zod_1 = require("zod");
exports.HookTypeEnum = zod_1.z.enum([
    'win',
    'discovery',
    'heads_up',
    'steady',
    'first_report',
    'window_verdicts_multiple',
    'window_verdict_keep',
    'window_verdict_fuzzy',
    'window_verdict_step_back',
    'window_closing',
]);
/**
 * Interpolation data emitted by the backend for window observation hook types.
 * The frontend resolves the user-facing string via i18n using these values.
 * Not all fields are used by every window type — each type picks the subset it
 * needs (e.g. window_verdicts_multiple uses count only).
 */
exports.HookWindowParamsSchema = zod_1.z.object({
    productName: zod_1.z.string().optional(),
    windowWeeks: zod_1.z.number().int().optional(),
    count: zod_1.z.number().int().optional(),
});
const WINDOW_HOOK_TYPE_VALUES = [
    'window_verdicts_multiple',
    'window_verdict_keep',
    'window_verdict_fuzzy',
    'window_verdict_step_back',
    'window_closing',
];
exports.HookObservationSchema = zod_1.z
    .object({
    type: exports.HookTypeEnum,
    /** Present for non-window hook types (LLM-generated or static template). */
    body: zod_1.z.string().max(280).optional(),
    /** Present for window hook types — frontend renders via i18n interpolation. */
    windowParams: exports.HookWindowParamsSchema.optional(),
})
    .superRefine((data, ctx) => {
    const isWindow = WINDOW_HOOK_TYPE_VALUES.some((t) => t === data.type);
    if (isWindow && data.windowParams === undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['windowParams'],
            message: `windowParams required for window hook type "${data.type}"`,
        });
    }
    if (!isWindow && data.body === undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['body'],
            message: `body required for non-window hook type "${data.type}"`,
        });
    }
});
//# sourceMappingURL=hook.js.map